import { useDevTools } from '../AppContext';

export const useGetAppLinks = () => {
  const signingURL =  '/signin-sms'
  const signupURL = '/quick-signup'
 return {
    signIn: signingURL,
   signUp: signupURL
  }
}
